import { Alert, Box } from '@mui/material';

import { CasBaseDialog, CasButton } from 'src/compass/shared/components';
import { SmsTextAdjustmentType } from './smsSpamSafeText';

interface Props {
  adjustments: SmsTextAdjustmentType[];
  onSendAsIs: VoidFunction;
  onApply: VoidFunction;
  // Also what closing the dialog does: back to the window, nothing sent, the text as written.
  onCancel: VoidFunction;
}

/*
  Asked when a single text has something carriers score as spam (see makeSmsSpamSafe).

  The sender has their one message in front of them and may need it exactly as written - a price
  can read better with its "$" - so the rewording is suggested rather than imposed: Send As Is
  sends their words, Apply Adjustment and Send sends the reworded text listed here, and Back to
  Editor sends nothing. A batch has a body per customized row, most of them off screen, so it
  rewords them all in place and stops for the sender to review them instead.
*/
export default function SmsSpamWarningDialog({
  adjustments,
  onSendAsIs,
  onApply,
  onCancel,
}: Props) {
  return (
    <CasBaseDialog
      open
      fullScreen={false}
      title="This text may be treated as spam"
      onClose={onCancel}
      actions={
        <>
          <CasButton color="secondary" variant="outlined" onClick={onCancel}>
            Back to Editor
          </CasButton>
          <CasButton variant="outlined" onClick={onSendAsIs}>
            Send As Is
          </CasButton>
          <CasButton onClick={onApply}>Apply Adjustment and Send</CasButton>
        </>
      }
    >
      <Alert severity="warning">
        Carriers can block a text with a dollar sign or a date written with slashes, without
        reporting a failure. Apply Adjustment and Send rewords it first:
        <Box component="ul" sx={{ m: 0, mt: 0.5, pl: 2.5 }}>
          {adjustments.map((adjustment) => (
            <li key={`${adjustment.from}->${adjustment.to}`}>
              &quot;{adjustment.from}&quot; &rarr; &quot;{adjustment.to}&quot;
            </li>
          ))}
        </Box>
      </Alert>
    </CasBaseDialog>
  );
}
